// /* eslint-disable jsx-a11y/anchor-is-valid */
// import React from 'react'
// import { KTIcon, toAbsoluteUrl } from '../../../helpers'
// import { Dropdown1 } from '../../content/dropdown/Dropdown1'

// type Props = {
//   className: string
//   data?: any
// }

// const ListsWidget2: React.FC<Props> = ({ className, data }) => {
//   var newData =
//     data &&
//     Object.entries(data).map(([name, value]) => ({
//       name,
//       value,
//     }))
//   return (
//     <div className={`card ${className}`}>
//       {/* begin::Header */}
//       <div className='card-header border-0'>
//         <h3 className='card-title align-items-start flex-column'>
//           <span className='fw-bold mb-2 text-dark'>Top 5 Suppliers</span>
//           {/* <span className='text-dark fw-semibold fs-7'>Top 5 Waste Collectors</span> */}
//         </h3>
//         {/* <h3 className='card-title fw-bold text-dark'>Analytics</h3>
//         <span className='text-dark fw-semibold fs-7'>890,344 Sales</span> */}
//         {/* <div className='card-toolbar'>
//           <button
//             type='button'
//             className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
//             data-kt-menu-trigger='click'
//             data-kt-menu-placement='bottom-end'
//             data-kt-menu-flip='top-end'
//           >
//             <KTIcon iconName='category' className='fs-2' />
//           </button>
//           <Dropdown1 />
//         </div> */}
//       </div>
//       {/* end::Header */}
//       {/* begin::Body */}
//       <div className='card-body pt-2'>
//         {/* begin::Item */}
//         {newData.map((eachData, eachInd) => (
//           <div key={eachInd + 1 + ''} className='d-flex align-items-center mb-7'>
//             {/* begin::Avatar */}
//             <div className='symbol symbol-50px me-5'>
//               <span className='symbol-label'>
//                 <img
//                   src={toAbsoluteUrl('/media/svg/brand-logos/cust.png')}
//                   className='h-50 align-self-center'
//                   alt=''
//                 />
//               </span>
//             </div>
//             {/* end::Avatar */}
//             {/* begin::Text */}
//             <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
//               <div className='flex-grow-1 me-2'>
//                 <a href='#' className='text-gray-800 text-hover-primary fs-6 fw-bold'>
//                   {eachData.name}
//                 </a>
//                 {/* <span className='text-dark fw-semibold d-block fs-7'>Mark, Rowling, Esther</span> */}
//               </div>
//               {/* <span className='badge badge-light fw-bold my-2'>{eachData.value || ''}</span> */}
//               <span className='badge badge-light text-dark fw-bold my-2'>
//                 {(Number(eachData.value) || 0).toFixed(2)}
//               </span>
//             </div>
//           </div>
//         ))}
//       </div>
//       {/* end::Body */}
//     </div>
//   )
// }

// export { ListsWidget2 }



// /* eslint-disable jsx-a11y/anchor-is-valid */
// import React from 'react'
// import { KTIcon, toAbsoluteUrl } from '../../../helpers'
// import { Dropdown1 } from '../../content/dropdown/Dropdown1'

// type Props = {
//   className: string
//   data?: any
// }

// const ListsWidget2: React.FC<Props> = ({ className, data }) => {
//   var newData =
//     data &&
//     Object.entries(data).map(([name, value]) => ({
//       name,
//       value,
//     }))
//   return (
//     <div className={`card ${className}`}>
//       {/* begin::Header */}
//       <div className='card-header border-0'>
//         <h3 className='card-title align-items-start flex-column'>
//           <span className='fw-bold mb-2 text-dark'>Top 5 Suppliers</span>
//           {/* <span className='text-dark fw-semibold fs-7'>Top 5 Waste Collectors</span> */}
//         </h3>
//         {/* <h3 className='card-title fw-bold text-dark'>Analytics</h3>
//         <span className='text-dark fw-semibold fs-7'>890,344 Sales</span> */}
//         {/* <div className='card-toolbar'>
//           <button
//             type='button'
//             className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
//             data-kt-menu-trigger='click'
//             data-kt-menu-placement='bottom-end'
//             data-kt-menu-flip='top-end'
//           >
//             <KTIcon iconName='category' className='fs-2' />
//           </button>
//           <Dropdown1 />
//         </div> */}
//       </div>
//       {/* end::Header */}
//       {/* begin::Body */}
//       <div className='card-body pt-2'>
//         {/* begin::Item */}
//         {newData.map((eachData, eachInd) => (
//           <div key={eachInd + 1 + ''} className='d-flex align-items-center mb-7'>
//             {/* begin::Avatar */}
//             <div className='symbol symbol-50px me-5'>
//               <span className='symbol-label'>
//                 <img
//                   src={toAbsoluteUrl('/media/svg/brand-logos/cust.png')}
//                   className='h-50 align-self-center'
//                   alt=''
//                 />
//               </span>
//             </div>
//             {/* end::Avatar */}
//             {/* begin::Text */}
//             <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
//               <div className='flex-grow-1 me-2'>
//                 <a href='#' className='text-gray-800 text-hover-primary fs-6 fw-bold'>
//                   {eachData.name}
//                 </a>
//                 {/* <span className='text-dark fw-semibold d-block fs-7'>Mark, Rowling, Esther</span> */}
//               </div>
//               {/* <span className='badge badge-light fw-bold my-2'>{eachData.value || ''}</span> */}
//               <span className='badge badge-light text-dark fw-bold my-2'>
//                 {(Number(eachData.value) || 0).toFixed(2)}
//               </span>
//             </div>
//           </div>
//         ))}
//       </div>
//       {/* end::Body */}
//     </div>
//   )
// }

// export { ListsWidget2 }





/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { Dropdown1 } from '../../content/dropdown/Dropdown1'

type Props = {
  className: string
  data?: any
  title?: string
}

const ListsWidget2: React.FC<Props> = ({ className, data, title = "Top 5 Plastic Keepers" }) => {
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='fw-bold mb-2 text-dark'>{title}</span>
        </h3>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body pt-2'>
        {/* begin::Item */}
        {Array.isArray(data) && data.map((eachData, eachInd) => (
          <div key={eachInd} className='d-flex align-items-center mb-7'>
            {/* begin::Avatar */}
            <div className='symbol symbol-50px me-5'>
              <span className='symbol-label'>
                <img
                  src={eachData.profileUrl || toAbsoluteUrl('/media/svg/brand-logos/cust.png')}
                  className='w-100 h-100 object-fit-cover'
                  style={{ borderRadius: '8px' }}
                  alt={eachData.name || ''}
                />
              </span>
            </div>
            {/* end::Avatar */}
            {/* begin::Text */}
            <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
              <div className='flex-grow-1 me-2'>
                <a href='#' className='text-gray-800 text-hover-primary fs-6 fw-bold'>
                  {(eachData.name || 'Unknown').length > 25
                    ? (eachData.name || 'Unknown').substring(0, 25) + '...'
                    : (eachData.name || 'Unknown')
                  }
                </a>
              </div>
              <span className='badge badge-light text-dark fw-bold my-2'>
                {(Number(eachData.quantity) || 0).toLocaleString("en", { maximumFractionDigits: 2 })} kgs
              </span>
            </div>
          </div>
        ))}
      </div>
      {/* end::Body */}
    </div>
  )
}

export { ListsWidget2 }